import { useEffect } from 'react';

interface WebVitalsMetric {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
}

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const useWebVitals = (onMetric?: (metric: WebVitalsMetric) => void) => {
  useEffect(() => {
    // Only load web vitals in production
    if (process.env.NODE_ENV === 'production' && onMetric) {
      import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
        onCLS(onMetric);
        onINP(onMetric); // FID has been replaced with INP
        onFCP(onMetric);
        onLCP(onMetric);
        onTTFB(onMetric);
      }).catch(console.error);
    }
  }, [onMetric]);
};

// Default implementation that logs to console
export const useWebVitalsLogger = () => {
  useWebVitals((metric) => {
    console.log(`Web Vital: ${metric.name}`, {
      value: metric.value,
      rating: metric.rating
    });
    
    // Send to analytics service if needed
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', metric.name, {
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_category: 'Web Vitals',
        event_label: metric.rating,
        non_interaction: true,
      });
    }
  });
};